import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectorRef, NgModule, ViewChild, ElementRef, OnInit, AfterViewInit, Renderer2 } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ITaskResponse, ITaskCommentPost } from './../../../modules/tasks/model/types';
import { TaskDataService } from '../../../shared/services/task-data.service';
import { BehaviorSubject, lastValueFrom, Observable, of } from 'rxjs';
import { map, shareReplay, catchError } from 'rxjs/operators';
import { LoggingService } from '../../../framework/logging/logging.service';
import { SeverityLevel } from '../../../framework/logging/severity-level.model';
import notify from 'devextreme/ui/notify';
import { sendNotificationMessage } from '../../../types/resource';
import { CommonModule } from '@angular/common';
import { ProfileDataService } from '../../../shared/services/profile-data.service';
import { FormUtils } from '../../../shared/components/framework/services/form-builder.service';
import { ChatComponent } from '../../../shared/components/chat/chat.component';
import { FileUploadComponent } from '../../../shared/components/dynamic-form-widgets/file-upload/file-upload.component';
import { environment } from '../../../../environments/environment';
import { MessageService } from '../../../shared/components/framework/services/message.service';
import { FormatAndCapitalizePipe, FormatBooleanNumersDatesPipe } from '../../../pipes/pipes';
import { locale } from 'devextreme/localization';
import { UtilitiesService } from '../../../shared/components/framework/services/utilities.service';
import { IUser } from '../../../modules/deal/model/types';
import { UtilService } from '../../../shared/services/util.service';
import { fakeAsync } from '@angular/core/testing';
import { format } from 'date-fns';


@Component({
  selector: 'app-task-detail',
  templateUrl: './task-detail.component.html',
  styleUrls: ['./task-detail.component.css'],
  providers: [CurrencyPipe]
})



export class TaskDetailComponent implements  OnChanges, OnInit, AfterViewInit {

  @ViewChild('formElement') formElement!: ElementRef;
  @ViewChild('accordion', { read: ElementRef }) accordionElement!: ElementRef;

  @Input() selectedTask: ITaskResponse;
  @Input() isEditable: boolean = false;
  @Input() isCompleteable: boolean = false;
  @Input() isTaskDetailLoaded: boolean = false;
  @Input() selectedSectionIndex:any;
  @Output() closePanelEmitter: EventEmitter<any> = new EventEmitter();
  @Output() refreshEmitter: EventEmitter<any> = new EventEmitter();

  objectKeys: string[];
  formattedDataObjectKeys: string[];
  contentTitle: string;
  taskStatuses: any[];
  allUsers: any[];
  files: File[] = [];
  taskToEdit: ITaskResponse;
  markAsComplete: boolean = false;
  notApplicable: boolean = false;
  buttonText: string;
  chatVisible: boolean = false;
  filesVisible: boolean = false;
  buttonEditorOptions: any;
  buttonTextSubject$ = new BehaviorSubject<string>('');
  buttonText$= this.buttonTextSubject$.asObservable();
  isDirtySubject$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isDirty$ =  this.isDirtySubject$.asObservable();
  taskToEditSubject$: BehaviorSubject<ITaskResponse> = new BehaviorSubject(null);
  taskToEdit$ =  this.taskToEditSubject$.asObservable();
  formattedTaskData: any;
  isDirty: boolean = false;
  buttonCancelOptions: any;
  userNameExpr: string;
  userIdExpr: string;
  selectedUser: IUser;
  sections = ['Task Details','Chat', 'Task History'];
  selectedTaskChanged: boolean = false;
  selectedRowData: any[] = [];
  formatNumberPipe: FormatBooleanNumersDatesPipe = new FormatBooleanNumersDatesPipe(locale());
  formatAndCapitalizePipe: FormatAndCapitalizePipe = new FormatAndCapitalizePipe();
  editableFields: object[] = [
    {
      prefix: "SUS",
      fields: [
        { name: "amount", format: "currency" }
      ]
    },
    {
      prefix: "BOD",
      fields: [
        { name: "dateFunded", format: "date" },
        { name: "dateReceived", format: "date" },
        { name: "monthBilledToClient", format: "" }
      ]
    },
    {
      prefix: "POD",
      fields: [
        { name: "nextTaxDueDate", format: "date" },
        { name: "expectedPayoffDate", format: "date" },
      ]
    },
    {
      prefix: "TRE",
      fields: [
        { name: "accountNotOpenedByMs", format: "" },
        { name: "isInterestBearing", format: "" },
      ]
    },
    {
      prefix: "VOU",
      fields: [
        { name: "fedReferenceNumbers", format: "text-input-grid" }
      ]
    },
    {
      prefix: "NDO",
      fields: [
        {
          name: "lsaAssignment",
          format: "select",
          dataSource: {
            serviceName: "ProfileDataService",
            methodName: "getUsersByGroup",
            methodParams: [["Loan Servicing"]],
            valueExpr: "id",
            displayExpr: "name"
          }
        },
        {
          name: "amAssignee",
          format: "select",
          dataSource: {
            serviceName: "ProfileDataService",
            methodName: "getUsersByGroup",
            methodParams: [["Asset Management"]],
            valueExpr: "id",
            displayExpr: "name"
          }
        },
        { name: "loanNumbersData", format: "loan-numbers-grid" },
        { name: "referenceName", format: "" }
      ],
    }
  ];
  loanNumbersGridRows: { key: string; loanNumber: string }[] = [];
  loanNumbersGridInstance: any;
  fedReferenceGridRows: { key: string; reference: string }[] = [];
  fedReferenceGridInstance: any;

  // Track original values and pending changes for editable fields
  private originalFieldValues: { [key: string]: any } = {};
  private pendingFieldChanges: Array<{ name: string; oldValue: any; newValue: any; comment?: string }> = [];
  // Cache for dropdown data sources
  fieldDataSources: { [key: string]: Observable<any> } = {};

  // Field change comment popup properties
  fieldChangeCommentPopupVisible: boolean = false;
  pendingFieldChange: { fieldKey: string; oldValue: any; newValue: any; formattedOldValue?: string; formattedNewValue?: string } | null = null;
  // Track temporary field changes before user finishes editing
  private temporaryFieldChanges: { [key: string]: any } = {};

  // Track SUS amount updates for loading state and parent update
  isSavingSUSAmount: boolean = false;

  @ViewChild('chats', { static: false }) chatInstance: ChatComponent;
  @ViewChild('fileUpload', { read: FileUploadComponent, static: true}) fileUploaderInstance!: any;
  @ViewChild('tooltipContainer', { read: ElementRef }) tooltipContainer!: ElementRef;

  // Loading state for save action
  isSaving: boolean = false;




  selectedIndex: any;
  selectedItems: string[];
  sharepointRootUrl = environment.sharePoint_Url+'/Shared Documents/General/';;
  hasAttchments: boolean = false;

  // Tooltip visibility control
  tooltipVisible: boolean = false;
  private tooltipHideTimer: any = null;

  constructor(
    private taskDataService: TaskDataService,
    private ref: ChangeDetectorRef,
    private profileDataService: ProfileDataService,
    private readonly loggingService: LoggingService, private readonly messageService: MessageService,
    private readonly currencyPipe: CurrencyPipe, private readonly utilService: UtilService,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer) {


      this.onCancelClick = this.onCancelClick.bind(this);
      this.buttonText$.subscribe((data:string)=> {this.buttonText = data;})
      this.isDirty$.subscribe((data: boolean)  => {this.isDirty = data});
      this.taskToEdit$.subscribe((data: ITaskResponse)  => {this.taskToEdit = data});
      this.buttonTextSubject$.next("Save Changes");
      this.buttonEditorOptions ={  text: this.buttonText, useSubmitBehavior: true, disabled: !this.isDirty || !this.isEditable, width:'100%'};
      this.buttonCancelOptions = { text: "Dismiss", onClick:this.onCancelClick, width:'200px'}


   }

  async getUserData()
  {
    try{
      this.taskStatuses = [{name:"Open"},{name:"Complete"}];
      if(this.selectedTask.team != null && this.selectedTask.team != undefined && this.selectedTask.team != '')
      {
        this.userNameExpr = 'name';
        const data = await lastValueFrom(this.profileDataService.getUsersByGroup([this.selectedTask.team]));
        console.log('getUsersByGroup response:', data);
        this.allUsers = data[1].flatMap(item => item.users);
        console.log('Team users loaded:', this.allUsers.length, 'users from team:', this.selectedTask.team);
        console.log('User IDs in team:', this.allUsers.map(u => ({ id: u.id, name: u.name })));
      } else {
        this.userNameExpr = 'fullName';
        const userData = await lastValueFrom(this.profileDataService.getAllUsers(false));
        this.allUsers = userData[1];
        console.log('All users loaded:', this.allUsers.length, 'users');
      }
      this.userIdExpr = 'id';
    }
    catch(err: any)
    {
      this.loggingService.logError(err, SeverityLevel.Error);
      notify(err.message, 'error', this.utilService.getNotificationTimeout());
    }
  }

   openUrlInNewTab(): void {
     let endpointUrl = this.sharepointRootUrl + this.selectedTask.taskId;
    if (this.selectedTask.parentId) {
       endpointUrl = this.sharepointRootUrl + this.selectedTask.parentTaskId;
    }
    window.open(endpointUrl, '_blank');
  }

   onCancelClick(e:any)
   {
    this.markAsComplete = false;
    this.notApplicable = false;
    this.selectedTaskChanged = false;
    this.buttonTextSubject$.next("Save Changes");
    this.setIsDirty(false);
    this.taskToEditSubject$.next(null);
    this.closePanelEmitter.emit(false);

   }

   clearAllFiles()
   {
    this.files.length = 0;
    if (this.fileUploaderInstance) {
      this.fileUploaderInstance.clearAllFiles();
    }
   }

  onCompleteChanged(e: any) {
    this.markAsComplete = e.value;
    if(e.value == true)
    {
      this.buttonTextSubject$.next("Complete");
    }
    else{
      this.buttonTextSubject$.next("Save Changes");
    }
    this.setIsDirty(true);
  }

  onNotApplicableChanged(e: any) {
    this.notApplicable = e.value;
    if(e.value == true)
    {
      this.buttonTextSubject$.next("Not Applicable");
    }
    else{
      this.buttonTextSubject$.next("Save Changes");
    }
    this.setIsDirty(true);
  }

  private async performSaveAction(): Promise<void> {
    // Check if we're saving an amount field on a SUS task
    const isSUSTask = this.selectedTask.taskId?.substring(0, 3).toUpperCase() === 'SUS';
    const hasAmountChange = this.pendingFieldChanges.some(change =>
      change.name.toLowerCase() === 'amount'
    );

    if (isSUSTask && hasAmountChange) {
      this.isSavingSUSAmount = true;
    }

    this.isSaving = true;
    try {
      // Append any editable field changes to taskData and post comments before submitting
      await this.appendEditedFieldsToTaskData();
      let formData = FormUtils.mapToFormData(this.taskToEdit);
      this.files.forEach((f) => {formData.append('files', f, f.name)});
      await lastValueFrom(this.taskDataService.updateTaskAsFormData(formData));

      // Success notification now handled by service layer
      // Keep message service for SignalR notifications
      sendNotificationMessage(`Task ${this.selectedTask.taskId} updated`, this.messageService);

      this.refreshEmitter.emit();
      this.clearAllFiles();
      this.selectedTaskChanged = false;
      this.markAsComplete = false;
      this.notApplicable = false;
      this.buttonTextSubject$.next("Save Changes");
    } finally {
      // Always clear the loading flag
      this.isSavingSUSAmount = false;
      this.isSaving = false;
    }
  }

   async onSubmit(e: any)
   {
    e.preventDefault();
    try{
      this.taskToEdit.action = this.buttonText;

      this.setIsDirty(false);
      if (this.selectedUser) {
        this.taskToEdit.assignedUserId = this.selectedUser.id;
        this.taskToEdit.assignedUserName = this.selectedUser.name;
      }

      await this.performSaveAction();
      // Success notification handled by service
    }
    catch(err: any)
    {
      this.loggingService.logError(err, SeverityLevel.Error);
      notify(
        this.utilService.buildTaskErrorMessage(this.selectedTask.taskId, 'update', err.message),
        'error',
        this.utilService.getNotificationTimeout()
      );
    }

    this.selectedTaskChanged = false;
    return false;
   }

   copyTaskDataToClipboard() {
     try {
       if (!this.taskToEdit?.prettifiedTaskDataArray) {
         notify('No task data available to copy', 'warning', this.utilService.getNotificationTimeout());
         return;
       }

       // Format the data as readable text
       const formattedText = this.taskToEdit.prettifiedTaskDataArray
         .map(item => {
           const key = this.formatAndCapitalizePipe.transform(item.key);
           const values = item.value
             .map(val => this.shouldFormatFieldValue(item.key) ?
               this.formatNumberPipe.transform(val) : val)
             .join('\n  ');
           return `${key}:\n  ${values}`;
         })
         .join('\n\n');

       // Copy to clipboard using modern API
       if (navigator.clipboard && window.isSecureContext) {
         navigator.clipboard.writeText(formattedText).then(() => {
           notify('Task data copied to clipboard', 'success', this.utilService.getNotificationTimeout());
         }).catch(err => {
           this.loggingService.logError(err, SeverityLevel.Error);
           notify('Failed to copy task data - clipboard access denied', 'error', this.utilService.getNotificationTimeout());
         });
       } else {
         notify('Clipboard access not available in this browser', 'warning', this.utilService.getNotificationTimeout());
       }

     } catch (err: any) {
       this.loggingService.logError(err, SeverityLevel.Error);
       notify('Failed to copy task data', 'error', this.utilService.getNotificationTimeout());
     }
   }

   shouldFormatFieldValue(key: string): boolean {
     // Don't format currency field value - keep it as-is (e.g., "EUR" not "E U R")
     return key.toLowerCase() !== 'currency';
   }

   getCurrencySymbol(currencyCode: string): string {
     try {
       // Get the currency symbol using Angular's currency pipe
       const sampleAmount = 0;
       const formatted = this.currencyPipe.transform(sampleAmount, currencyCode, 'symbol-narrow', '1.0-2') || '';

       // Extract the symbol (everything before any digits)
       const symbolMatch = formatted.match(/^([^\d.,]*)/);
       return symbolMatch ? symbolMatch[1].trim() : currencyCode;
     } catch (error) {
       // Fallback to currency code if pipe fails
       return currencyCode;
     }
   }

   formatAmountWithCurrency(value: any, currencyCode?: string): string {
     if (typeof value === 'number' || (typeof value === 'string' && !isNaN(Number(value)))) {
       const numValue = Number(value);
       if (currencyCode) {
         // Use currency pipe to format with proper symbol
         return this.currencyPipe.transform(numValue, currencyCode, 'symbol-narrow', '1.2-2') || value.toString();
       } else {
         // Format as number without currency
         return this.formatNumberPipe.transform(value);
       }
     }
     return value;
   }

   formatAmountFieldsInObject(obj: any, currencyCode?: string): any {
     if (obj === null || obj === undefined) {
       return obj;
     }

     if (Array.isArray(obj)) {
       // Handle arrays by recursively formatting each element
       return obj.map(item => this.formatAmountFieldsInObject(item, currencyCode));
     }

     if (typeof obj === 'object') {
       // Handle objects by checking each property
       const formattedObject: any = {};
       for (const [key, value] of Object.entries(obj)) {
         if ((key.toLowerCase().includes('amount') || key.toLowerCase().includes('fee')) && (typeof value === 'number' || (typeof value === 'string' && !isNaN(Number(value))))) {
           // Format amount fields
           formattedObject[key] = this.formatAmountWithCurrency(value, currencyCode);
         } else if (typeof value === 'object') {
           // Recursively handle nested objects
           formattedObject[key] = this.formatAmountFieldsInObject(value, currencyCode);
         } else {
           // Keep other values as-is
           formattedObject[key] = value;
         }
       }
       return formattedObject;
     }

     // Return primitive values as-is
     return obj;
   }

   formatTaskData()
   {
    try{
      let jsonData = this.taskToEdit.taskData;
      if(jsonData == null || jsonData == undefined || jsonData == '')
        return;

      let data = JSON.parse(jsonData);

      // Store the parsed data as a separate property for easy access in editable fields
      (this.taskToEdit as any).parsedTaskData = data;

      // Capture original values for editable fields
      this.captureOriginalFieldValues();

      // Extract currency code if it exists
      let currencyCode = data.currencyCode || data.currency;
      if (!currencyCode || currencyCode == '') {
        currencyCode = 'USD';
      }

      // Ensure isUrgent appears first, requestType second, and description appears last
      const entries = Object.entries(data);
      const requestTypeEntry = entries.find(([key]) => key === 'requestType');
      const isUrgentEntry = entries.find(([key]) => key === 'isUrgent');
      const descriptionEntry = entries.find(([key]) => key === 'description');
      const otherEntries = entries.filter(([key]) =>
        key !== 'requestType' && key !== 'isUrgent' && key !== 'currencyCode' && key !== 'description' && key !== 'editedFields' && key !== 'loanNumbers' // Filter out internal fields
      );

      // Sort other entries alphabetically by key
      otherEntries.sort(([keyA], [keyB]) => keyA.localeCompare(keyB));

      // Build ordered entries: isUrgent first, requestType second, others in alphabetical order, description last
      let orderedEntries = [];
      if (isUrgentEntry) orderedEntries.push(isUrgentEntry);
      if (requestTypeEntry) orderedEntries.push(requestTypeEntry);
      orderedEntries.push(...otherEntries);
      if (descriptionEntry) orderedEntries.push(descriptionEntry);

      this.taskToEdit.prettifiedTaskDataArray = orderedEntries.map(([key, value]) => {
        if (Array.isArray(value)) {
          // Check if array contains objects
          if (value.length > 0 && typeof value[0] === 'object' && value[0] !== null) {
            // Special handling for selectedLoanBorrowers - only show borrower names
            if (key === 'selectedLoanBorrowers') {
              const formatted = value.map(item => item.borrower || '').filter(b => b);
              return { key, value: formatted };
            }

            // Special handling for loanNumbersData - show one loan number per line
            if (key === 'loanNumbersData') {
              return { key, value: value.map((item: any) => item.loanNumber || '').filter((ln: string) => ln) };
            }

            // Special handling for fedReferenceNumbers - show one reference per line
            if (key === 'fedReferenceNumbers') {
              return { key, value: value.map((item: any) => item.reference || '').filter((r: string) => r) };
            }

            // Format array of objects as readable strings
            const formatted = value.map(item => {
              const parts: string[] = [];

              // Add each property as "key: value"
              Object.entries(item).forEach(([propKey, propValue]) => {
                // Skip internal properties like 'key' used by grids
                if (propKey === 'key') return;

                // Format amounts with currency
                if (propKey.toLowerCase().includes('amount') && (typeof propValue === 'number' || !isNaN(Number(propValue)))) {
                  parts.push(`${propKey}: ${this.formatAmountWithCurrency(propValue, currencyCode)}`);
                } else if (propValue !== null && propValue !== undefined && propValue !== '') {
                  parts.push(`${propKey}: ${propValue}`);
                }
              });

              return parts.join(', ');
            });
            return { key, value: formatted };
          } else {
            // Array of primitives
            return { key, value: value.map(item => String(item)) };
          }
        } else if (typeof value === 'object' && value !== null) {
          // Handle nested JSON objects and format any amount fields within them
          const formattedObject = this.formatAmountFieldsInObject(value, currencyCode);
          return { key, value: [JSON.stringify(formattedObject, null, 2)] }; // Pretty print with indentation
        }
        else if (key.toLowerCase().includes('amount') || key.toLowerCase().includes('fee')) {
          // Format any field containing 'amount' in its key with currency
          return { key, value: [this.formatAmountWithCurrency(value, currencyCode)] };
        }
        else if (key === 'agent') {
          const agentDisplayMap: { [k: string]: string } = {
            noAgent: 'None',
            msAgent: 'MS',
            externalAgent: 'External'
          };
          return { key, value: [agentDisplayMap[value as string] ?? value] };
        }
        else if (typeof value === 'string' && value !== null && !UtilitiesService.isValidDate(value)) {
           // Check if this is a currency field - don't format the value if it is
           if (key.toLowerCase() === 'currency') {
             return { key, value: [value] }; // Keep currency value as-is
           } else {
             return { key,value: [value] }; // Format other string values
           }
         }
        else {
          return { key, value: [value] }; // Wrap primitive in array
        }
      });

      // Hydrate the loan numbers grid rows from parsedTaskData
      this.loanNumbersGridRows = [];
      const lnData = data.loanNumbersData;
      if (Array.isArray(lnData) && lnData.length > 0) {
        this.loanNumbersGridRows = lnData.map((item: any) => ({
          key: item.key || this.generateLoanNumberKey(),
          loanNumber: item.loanNumber || ''
        }));
      } else if (Array.isArray(data.loanNumbers) && data.loanNumbers.length > 0) {
        // Backwards compatibility: loanNumbers stored as array of strings
        this.loanNumbersGridRows = data.loanNumbers.map((ln: string) => ({
          key: this.generateLoanNumberKey(),
          loanNumber: ln
        }));
      }

      // Hydrate the fed reference numbers grid rows from parsedTaskData
      this.fedReferenceGridRows = [];
      const frData = data.fedReferenceNumbers;
      if (Array.isArray(frData) && frData.length > 0) {
        if (typeof frData[0] === 'object' && frData[0] !== null) {
          // Stored as array of { key, reference } objects
          this.fedReferenceGridRows = frData.map((item: any) => ({
            key: item.key || this.generateLoanNumberKey(),
            reference: item.reference || ''
          }));
        } else {
          // Backwards compatibility: stored as array of plain strings
          this.fedReferenceGridRows = frData.map((r: string) => ({
            key: this.generateLoanNumberKey(),
            reference: r
          }));
        }
      } else if (typeof frData === 'string' && frData.trim() !== '') {
        // Backwards compatibility: stored as a single string (previous plain text input)
        this.fedReferenceGridRows = frData.split('\n')
          .map((r: string) => r.trim())
          .filter((r: string) => r)
          .map((r: string) => ({ key: this.generateLoanNumberKey(), reference: r }));
      }

    }
    catch(err: any)
    {
      this.loggingService.logError(err, SeverityLevel.Error);
      notify(err.message, 'error', this.utilService.getNotificationTimeout());
    }
   }

   getTruncatedText(text: any, maxLength: number): string {
     if (!text && text !== 0 && text !== false) return '';

     // Convert to string if it's not already a string
     const stringValue = typeof text === 'string' ? text : String(text);

     if (stringValue.length <= maxLength) return stringValue;
     return stringValue.substring(0, maxLength) + '...';
   }

   isDescriptionField(key: string): boolean {
     const lowercaseKey = key.toLowerCase();
     return lowercaseKey.includes('description') ||
            lowercaseKey.includes('comment') ||
            lowercaseKey.includes('note') ||
            lowercaseKey.includes('detail') ||
            lowercaseKey.includes('remarks');
   }

    shouldShowTaskTooltip(key: string): boolean {
     const shouldShow = key.toLowerCase() === 'name';
     return shouldShow;
   }

   getTaskTooltip(): string {
    const tooltip = this.taskToEdit?.tooltip || '';
    return tooltip;
   }

   private cachedDescriptionHtml: SafeHtml | null = null;
   private lastDescriptionValue: string | null = null;

   getTaskTooltipSafeHtml(): SafeHtml {
     const html = this.taskToEdit?.tooltip || '';
     // Cache the result to avoid re-sanitizing on every change detection
     if (html !== this.lastDescriptionValue) {
       this.lastDescriptionValue = html;
       this.cachedDescriptionHtml = this.sanitizer.bypassSecurityTrustHtml(html);
     }
     return this.cachedDescriptionHtml || '';
   }

   shouldShowTooltipIcon(key: string): boolean {
     if (key.toLowerCase() !== 'name') return false;
     const tooltip = this.taskToEdit?.tooltip;
     return tooltip && tooltip.trim() !== '';
   }

   onTooltipShown(): void {
     // Attach checkbox listeners when tooltip is fully shown
     setTimeout(() => {
       if (this.hasCheckboxes()) {
         this.attachCheckboxListeners();
       }
     }, 50);
   }

   onTooltipHiding(): void {
     // Remove checkbox listeners when tooltip is hiding
     if (this.hasCheckboxes()) {
       this.removeCheckboxListeners();
     }
   }

   showTooltip(): void {
     // Clear any pending hide timer
     if (this.tooltipHideTimer) {
       clearTimeout(this.tooltipHideTimer);
       this.tooltipHideTimer = null;
     }
     this.tooltipVisible = true;
   }

   hideTooltip(): void {
     // Add small delay before hiding
     this.tooltipHideTimer = setTimeout(() => {
       this.tooltipVisible = false;
     }, 100);
   }

   keepTooltipOpen(): void {
     // Cancel hide when mouse enters tooltip
     if (this.tooltipHideTimer) {
       clearTimeout(this.tooltipHideTimer);
       this.tooltipHideTimer = null;
     }
     this.tooltipVisible = true;
   }

   private hasCheckboxes(): boolean {
     const tooltip = this.taskToEdit?.tooltip || '';
     return tooltip.includes('<input') && tooltip.includes('type="checkbox"');
   }

   private attachCheckboxListeners(): void {
     const tooltipElement = document.querySelector('.dx-overlay-content .description-tooltip-content');
     if (tooltipElement) {
       tooltipElement.addEventListener('click', this.handleCheckboxClick.bind(this));
     }
   }

   private removeCheckboxListeners(): void {
     const tooltipElement = document.querySelector('.dx-overlay-content .description-tooltip-content');
     if (tooltipElement) {
       tooltipElement.removeEventListener('click', this.handleCheckboxClick.bind(this));
     }
   }

   private handleCheckboxClick(event: Event): void {
     const target = event.target as HTMLElement;

     if (target.tagName === 'INPUT' && (target as HTMLInputElement).type === 'checkbox') {
       const checkbox = target as HTMLInputElement;
       const listItem = checkbox.closest('li');
       const itemText = listItem?.textContent?.trim() || '';

       // Update the HTML in the description field
       this.updateCheckboxStateInDescription(checkbox);

       // Mark form as dirty and set action to Save Changes
       this.buttonTextSubject$.next('Save Changes');
       this.setIsDirty(true);

       // Trigger change detection since this handler runs outside Angular's zone
       this.ref.detectChanges();

       // Optional: Show notification
       notify(`Updated "${itemText}" to ${checkbox.checked ? 'completed' : 'incomplete'}`, 'info', this.utilService.getNotificationTimeout());
     }
   }

   private updateCheckboxStateInDescription(clickedCheckbox: HTMLInputElement): void {
     if (!this.taskToEdit?.tooltip) return;

     const parser = new DOMParser();
     const doc = parser.parseFromString(this.taskToEdit.tooltip, 'text/html');
     const checkboxes = doc.querySelectorAll('input[type="checkbox"]');

     // Get all current checkbox states from the DOM
     const tooltipElement = document.querySelector('.dx-overlay-content .description-tooltip-content');
     if (!tooltipElement) return;

     const currentCheckboxes = tooltipElement.querySelectorAll('input[type="checkbox"]');

     // Update the parsed HTML with current states
     checkboxes.forEach((checkbox, index) => {
       if (currentCheckboxes[index]) {
         const currentState = (currentCheckboxes[index] as HTMLInputElement).checked;
         if (currentState) {
           checkbox.setAttribute('checked', '');
         } else {
           checkbox.removeAttribute('checked');
         }
       }
     });

     // Update the tooltip with the new HTML and reset the SafeHtml cache
     const updatedHtml = doc.body.innerHTML;
     this.taskToEdit.tooltip = updatedHtml;
     this.lastDescriptionValue = null;
     this.cachedDescriptionHtml = null;
   }

   private isUserInLoanServicingTeam(): boolean {
     try {
       const userTeamsData = localStorage.getItem('userTeams');
       if (!userTeamsData) return false;
       console.log('User teams data from localStorage:', userTeamsData);
       let userTeams = JSON.parse(userTeamsData);

       // Ensure userTeams is an array
       if (!Array.isArray(userTeams)) {
         userTeams = [userTeams];
       }

       // Check if 'Loan Servicing' exists in the array (case-insensitive, trimmed)
       if(userTeams.some(team => typeof team === 'string' && team.trim().toLowerCase() === 'loan servicing')) {
          console.log('User is in Loan Servicing team');
          return true;
       }
       console.log('User is NOT in Loan Servicing team');
       return false;
     } catch (error) {
       this.loggingService.logError('Error parsing userTeams from localStorage', SeverityLevel.Error);
       console.error('Error parsing userTeams from localStorage:', error);
       return false;
     }
   }

   private isTaskCreator(): boolean {
     if (!this.taskToEdit) return false;
     const loggedInUser = localStorage.getItem('loggedInUser');
     return this.taskToEdit.createdBy === loggedInUser;
   }

   private getEditableFieldsForPrefix(taskPrefix: string): any[] {
     return this.editableFields
       .filter((fieldConfig: any) => fieldConfig.prefix === taskPrefix)
       .flatMap((fieldConfig: any) => fieldConfig.fields || []);
   }

   isFieldEditable(fieldKey: string): boolean {
     if (!this.taskToEdit?.taskId) return false;0

     // Extract the prefix (first 3 letters) from taskId
     const taskPrefix = this.taskToEdit.taskId.substring(0, 3).toUpperCase();

     const editableFields = this.getEditableFieldsForPrefix(taskPrefix);

     if (editableFields.length === 0) return false;

     // Check if this field is in the editable fields list (handle both string and object formats)
     const isConfiguredEditable = editableFields.some((field: any) => {
       const fieldName = typeof field === 'string' ? field : field.name;
       return fieldName.toLowerCase() === fieldKey.toLowerCase();
     });

     // If the field is in the configuration, check additional permissions for amount field
     if (isConfiguredEditable) {
       // For amount field, user must be either the creator OR in Loan Servicing team
        if (taskPrefix === 'SUS' && fieldKey.toLowerCase() === 'amount') {
          if(this.isUserInLoanServicingTeam()) {
            console.log('User is in Loan Servicing team - allowing edit of SUS amount field');
            return true;
          } else if(this.isTaskCreator()) {
            console.log('User is the task creator - allowing edit of SUS amount field');
            return true;
          } else {
            console.log('User is NOT in Loan Servicing team and NOT the task creator - denying edit of SUS amount field');
            return false;
          }
        }
        return true;
      }

     // Also check if the field has been edited historically (from previous saves)
     // This allows fields that were previously edited to remain editable
     if ((this.taskToEdit as any).parsedTaskData) {
       const editedFields = (this.taskToEdit as any).parsedTaskData.editedFields;
       if (editedFields && Array.isArray(editedFields)) {
         const hasHistoricalEdit = editedFields.some((edit: any) =>
           edit.name && edit.name.toLowerCase() === fieldKey.toLowerCase()
         );
         if (hasHistoricalEdit) return true;
       }
     }

     return false;
   }

   getFieldFormat(fieldKey: string): string | null {
     if (!this.taskToEdit?.taskId) return null;

     // Extract the prefix (first 3 letters) from taskId
     const taskPrefix = this.taskToEdit.taskId.substring(0, 3).toUpperCase();

     const editableFields = this.getEditableFieldsForPrefix(taskPrefix);

     if (editableFields.length > 0) {
       const fieldConfig = editableFields.find((field: any) => {
         const fieldName = typeof field === 'string' ? field : field.name;
         return fieldName.toLowerCase() === fieldKey.toLowerCase();
       });

       if (fieldConfig && typeof fieldConfig !== 'string') {
         return fieldConfig.format || null;
       }
     }

     // If not found in config, check if this field has been historically edited
     // and infer the format based on field name
     if ((this.taskToEdit as any).parsedTaskData) {
       const editedFields = (this.taskToEdit as any).parsedTaskData.editedFields;
       if (editedFields && Array.isArray(editedFields)) {
         const hasHistoricalEdit = editedFields.some((edit: any) =>
           edit.name && edit.name.toLowerCase() === fieldKey.toLowerCase()
         );

         if (hasHistoricalEdit) {
           // Infer format based on field name
           const lowerKey = fieldKey.toLowerCase();
           if (lowerKey.includes('amount') || lowerKey.includes('price') || lowerKey.includes('cost')) {
             return 'currency';
           }
           if (lowerKey.includes('quantity') || lowerKey.includes('count') || lowerKey.includes('number')) {
             return 'number';
           }
           // Default to text format for historically edited fields
           return 'text';
         }
       }
     }

     return null;
   }

   /**
    * Get field configuration for a specific field key
    */
   getFieldConfig(fieldKey: string): any {
     if (!this.taskToEdit?.taskId) return null;

     const taskPrefix = this.taskToEdit.taskId.substring(0, 3).toUpperCase();
     const editableFields = this.getEditableFieldsForPrefix(taskPrefix);

     if (editableFields.length === 0) return null;

     return editableFields.find((field: any) =>
       field.name?.toLowerCase() === fieldKey.toLowerCase()
     );
   }

   /**
    * Load data source for select fields from API
    */
   loadFieldDataSource(fieldKey: string): Observable<any> {
     // Check cache first
     if (this.fieldDataSources[fieldKey]) {
       return this.fieldDataSources[fieldKey];
     }

     const fieldConfig = this.getFieldConfig(fieldKey);
     if (!fieldConfig?.dataSource) {
       return of([]);
     }

     try {
       // Call the service method dynamically
       const { methodName, methodParams } = fieldConfig.dataSource;
       const dataSource = this.profileDataService[methodName](...methodParams).pipe(
         map((response: any) => {
           console.log('Raw API response for', fieldKey, ':', response);
           console.log('Response type:', typeof response, 'isArray:', Array.isArray(response));

           // Handle response structure: { result: [{ groupName, users: [] }] }
           let usersList = [];
           let groupsArray = null;

           // Check if response is array with message at index 0 and data at index 1
           if (Array.isArray(response) && response.length > 1 && typeof response[0] === 'string' && Array.isArray(response[1])) {
             console.log('Response is [message, data] format');
             groupsArray = response[1];
           }
           // Check if response has result property
           else if (response?.result && Array.isArray(response.result)) {
             console.log('Using response.result path');
             groupsArray = response.result;
           }
           // Check if response is already the groups array
           else if (Array.isArray(response) && response.length > 0 && response[0]?.users) {
             console.log('Response is already groups array');
             groupsArray = response;
           }
           // Handle direct array of users
           else if (Array.isArray(response) && response.length > 0 && response[0]?.id && response[0]?.name) {
             console.log('Response is direct users array');
             usersList = response;
           }

           // Extract users from groups array if we have one
           if (groupsArray && Array.isArray(groupsArray)) {
             console.log('Extracting users from groups:', groupsArray);
             groupsArray.forEach((group: any) => {
               if (group.users && Array.isArray(group.users)) {
                 usersList.push(...group.users);
               }
             });
           }

           console.log('Extracted usersList:', usersList);

           // Map to the expected format
           const mappedUsers = usersList.map((u: any) => {
             console.log('Mapping user:', u);
             return {
               id: u.id,
               name: u.name
             };
           });

           console.log('Mapped users for dropdown:', mappedUsers);
           return mappedUsers;
           return mappedUsers;
         }),
         shareReplay(1), // Cache the result
         catchError(err => {
           console.error('Error loading field data source:', err);
           this.loggingService.logError(`Failed to load field data source for ${fieldKey}`, SeverityLevel.Error);
           this.loggingService.logError(err, SeverityLevel.Error);
           return of([]);
         })
       );

       this.fieldDataSources[fieldKey] = dataSource;
       return dataSource;
     } catch (err) {
       this.loggingService.logError(`Error initializing field data source for ${fieldKey}`, SeverityLevel.Error);
       this.loggingService.logError(err, SeverityLevel.Error);
       return of([]);
     }
   }

   onEditableFieldValueChanged(fieldKey: string, newValue: any, selectedItem?: any): void {
     // Temporarily store the new value without showing popup yet
     // The popup will be shown when user finishes editing (blur or enter)
     if (!fieldKey || !this.taskToEdit || !(this.taskToEdit as any).parsedTaskData) {
       return;
     }

     // Update the temporary storage
     this.temporaryFieldChanges[fieldKey] = newValue;

     // Update the value in parsedTaskData immediately for UI feedback
     (this.taskToEdit as any).parsedTaskData[fieldKey] = newValue;

     // For select fields with related ID field, update both name and ID
     const fieldConfig = this.getFieldConfig(fieldKey);
     if (fieldConfig?.dataSource?.relatedField && selectedItem) {
       const relatedField = fieldConfig.dataSource.relatedField;
       (this.taskToEdit as any).parsedTaskData[relatedField] = selectedItem.id;
     }

     // Update the JSON string representation
     this.taskToEdit.taskData = JSON.stringify((this.taskToEdit as any).parsedTaskData);
   }

   /**
    * Handle value changes for select fields (dropdowns)
    * This method does NOT trigger the confirmation dialog but enables the Save button
    */
   onSelectFieldValueChanged(fieldKey: string, newValue: any, selectedItem?: any, previousValue?: any): void {
     if (!fieldKey || !this.taskToEdit || !(this.taskToEdit as any).parsedTaskData) {
       return;
     }

     // Update the value in parsedTaskData immediately
     (this.taskToEdit as any).parsedTaskData[fieldKey] = newValue;

     // For select fields with related ID field, update both name and ID
     const fieldConfig = this.getFieldConfig(fieldKey);
     if (fieldConfig?.dataSource?.relatedField && selectedItem) {
       const relatedField = fieldConfig.dataSource.relatedField;
       (this.taskToEdit as any).parsedTaskData[relatedField] = selectedItem.id;
     }

     // Update the JSON string representation
     this.taskToEdit.taskData = JSON.stringify((this.taskToEdit as any).parsedTaskData);

     // Enable Save button if value actually changed
     if (newValue !== previousValue) {
       this.setIsDirty(true);
       this.buttonEditorOptions = {
         disabled: false
       };
     }
   }

   onEditableFieldInput(fieldKey: string): void {
     // This method is called during input - we just track changes
     // but don't show the popup yet
   }

   onEditableFieldFocusOut(fieldKey: string): void {
     // Called when user leaves the field (blur event)
     if (!fieldKey) {
       return;
     }
     this.promptForCommentIfChanged(fieldKey);
   }

   onEditableFieldEnterKey(fieldKey: string, event: any): void {
     // Called when user presses Enter
     if (event?.preventDefault) {
       event.preventDefault();
     } else if (event?.event?.preventDefault) {
       event.event.preventDefault();
     }
     this.promptForCommentIfChanged(fieldKey);
   }

   private promptForCommentIfChanged(fieldKey: string): void {
     if (!this.taskToEdit || !(this.taskToEdit as any).parsedTaskData) return;

     // Get the original value
     const originalValue = this.originalFieldValues.hasOwnProperty(fieldKey)
       ? this.originalFieldValues[fieldKey]
       : null;

     // Get the current value
     const currentValue = (this.taskToEdit as any).parsedTaskData[fieldKey];

     // Only show popup if value has actually changed from original
     if (originalValue !== currentValue) {
       // Check if this change already has a comment (user edited it multiple times)
       const existingChange = this.pendingFieldChanges.find(c => c.name === fieldKey);

       if (!existingChange) {
         // Format the values for display
         const formattedOldValue = this.formatFieldValueForDisplay(fieldKey, originalValue);
         const formattedNewValue = this.formatFieldValueForDisplay(fieldKey, currentValue);

         // Store the pending change and show comment popup
         this.pendingFieldChange = {
           fieldKey: fieldKey,
           oldValue: originalValue,
           newValue: currentValue,
           formattedOldValue: formattedOldValue,
           formattedNewValue: formattedNewValue
         };

         // Show the comment popup
         this.fieldChangeCommentPopupVisible = true;
       } else {
         // Update the existing change with new value (keep the same comment)
         existingChange.newValue = currentValue;
         // Mark as dirty
         this.setIsDirty(true);
       }
     }

     // Clear temporary change tracking for this field
     delete this.temporaryFieldChanges[fieldKey];
   }

   async onFieldChangeCommentSubmit(comment: string): Promise<void> {
     if (!this.pendingFieldChange) return;

     const { fieldKey, oldValue, newValue } = this.pendingFieldChange;

     // Check if we already have a pending change for this field
     const existingChangeIndex = this.pendingFieldChanges.findIndex(c => c.name === fieldKey);

     if (existingChangeIndex >= 0) {
       // Update existing pending change with new value and comment
       this.pendingFieldChanges[existingChangeIndex].newValue = newValue;
       this.pendingFieldChanges[existingChangeIndex].comment = comment;
     } else {
       // Add new pending change, using original value if available
       const originalValue = this.originalFieldValues.hasOwnProperty(fieldKey)
         ? this.originalFieldValues[fieldKey]
         : oldValue;

       this.pendingFieldChanges.push({
         name: fieldKey,
         oldValue: originalValue,
         newValue: newValue,
         comment: comment
       });
     }

     // Update the value in parsedTaskData
     (this.taskToEdit as any).parsedTaskData[fieldKey] = newValue;
     // Update the JSON string representation
     this.taskToEdit.taskData = JSON.stringify((this.taskToEdit as any).parsedTaskData);

     // Close the popup and clear pending change
     this.fieldChangeCommentPopupVisible = false;
     this.pendingFieldChange = null;

     // Automatically save the task after comment submission
     try {
       // Set the action field before saving
       this.taskToEdit.action = this.buttonText;

       this.setIsDirty(false);
       await this.performSaveAction();
       // Success notification handled by service
     } catch (err: any) {
       this.loggingService.logError(err, SeverityLevel.Error);
       notify(
         this.utilService.buildTaskErrorMessage(this.selectedTask.taskId, 'save field change', err.message),
         'error',
         this.utilService.getNotificationTimeout()
       );
       // Restore dirty state if save failed
       this.setIsDirty(true);
     }

     // Trigger change detection to update the UI
     this.ref.detectChanges();
   }

   onFieldChangeCommentCancel(): void {
     if (!this.pendingFieldChange) return;

     const { fieldKey, oldValue } = this.pendingFieldChange;

     // Revert the value back to old value in parsedTaskData
     (this.taskToEdit as any).parsedTaskData[fieldKey] = oldValue;
     // Update the JSON string representation
     this.taskToEdit.taskData = JSON.stringify((this.taskToEdit as any).parsedTaskData);

     // Close the popup and clear pending change
     this.fieldChangeCommentPopupVisible = false;
     this.pendingFieldChange = null;

     // Trigger change detection to update the UI with reverted value
     this.ref.detectChanges();
   }

   getFieldChangeCommentPopupTitle(): string {
     return 'Change Comment Required';
   }

   formatFieldValueForDisplay(fieldKey: string, value: any): string {
     if (value === null || value === undefined) return 'N/A';

     const format = this.getFieldFormat(fieldKey);

     if (format === 'currency') {
       // Get currency code from task data if available
       const currencyCode = this.taskToEdit && (this.taskToEdit as any).parsedTaskData
         ? ((this.taskToEdit as any).parsedTaskData.currencyCode || (this.taskToEdit as any).parsedTaskData.currency)
         : null;

       if (typeof value === 'number' || (typeof value === 'string' && !isNaN(Number(value)))) {
         const numValue = Number(value);
         if (currencyCode) {
           return this.currencyPipe.transform(numValue, currencyCode, 'symbol-narrow', '1.2-2') || String(value);
         } else {
           // Default to USD if no currency code
           return this.currencyPipe.transform(numValue, 'USD', 'symbol-narrow', '1.2-2') || String(value);
         }
       }
       return String(value);
     } else if (format === 'number') {
       if (typeof value === 'number' || (typeof value === 'string' && !isNaN(Number(value)))) {
         return this.formatNumberPipe.transform(value);
       }
       return String(value);
     } else {
       // Text format (default)
       return String(value);
     }
   }

   getFieldValue(fieldKey: string): any {
     if (!this.taskToEdit || !(this.taskToEdit as any).parsedTaskData) return null;
     return (this.taskToEdit as any).parsedTaskData[fieldKey];
   }

   getFieldLabel(key: string): string {
     // Get task prefix if available
     const taskPrefix = this.taskToEdit?.taskId?.substring(0, 3).toUpperCase();

     // Static label overrides
     const labelOverrides: { [key: string]: string } = {
       isUrgent: 'Rush Job',
     };

     // Prefix-specific label overrides
     if (taskPrefix === 'VOU' && key === 'dueDate') {
       return 'Voucher Due Date';
     }

     return labelOverrides[key] ?? this.formatAndCapitalizePipe.transform(key);
   }

   isTruthyTaskDataValue(value: any): boolean {
     return value === true || value === 'true' || value === 'True' || value === 'TRUE' || value === 'Yes';
   }

   isUrgentTask(): boolean {
     const parsedTaskData = (this.taskToEdit as any)?.parsedTaskData;
     if (parsedTaskData && Object.prototype.hasOwnProperty.call(parsedTaskData, 'isUrgent')) {
       return this.isTruthyTaskDataValue(parsedTaskData.isUrgent);
     }

     const rawTaskData = this.taskToEdit?.taskData || this.selectedTask?.taskData;
     if (!rawTaskData) {
       return false;
     }

     try {
       const taskData = typeof rawTaskData === 'string' ? JSON.parse(rawTaskData) : rawTaskData;
       return this.isTruthyTaskDataValue(taskData?.isUrgent);
     } catch {
       return false;
     }
   }

   shouldRenderUrgentBadge(itemKey: string, value: any): boolean {
     return itemKey === 'isUrgent' && this.isTruthyTaskDataValue(value);
   }

   private generateLoanNumberKey(): string {
     return Date.now().toString() + Math.random().toString(36).substr(2, 9);
   }

   onLoanNumbersGridInitialized(e: any): void {
     this.loanNumbersGridInstance = e.component;
   }

   addLoanNumberRow(): void {
     if (this.loanNumbersGridInstance) {
       this.loanNumbersGridInstance.addRow();
     }
   }

   onLoanNumberInitNewRow(e: any): void {
     e.data.key = this.generateLoanNumberKey();
   }

  isLoanNumberDuplicate(e: any): boolean {
    const newValue = (e.value || '').trim().toLowerCase();
    if (!newValue) return true;
    return !this.loanNumbersGridRows.some(
      row => row.key !== e.data?.key &&
             (row.loanNumber || '').trim().toLowerCase() === newValue
    );
  }

  onLoanNumbersGridRowCommitted(): void {
    if (!this.taskToEdit || !(this.taskToEdit as any).parsedTaskData) return;

    const rows = [...this.loanNumbersGridRows];
    (this.taskToEdit as any).parsedTaskData.loanNumbersData = rows;
    (this.taskToEdit as any).parsedTaskData.loanNumbers = rows.map(r => r.loanNumber);
    this.taskToEdit.taskData = JSON.stringify((this.taskToEdit as any).parsedTaskData);

    // Enable Save Changes button without showing the comment popup
    this.buttonTextSubject$.next('Save Changes');
    this.setIsDirty(true);
    this.buttonEditorOptions = { disabled: false };
  }

  onFedReferenceGridInitialized(e: any): void {
    this.fedReferenceGridInstance = e.component;
  }

  addFedReferenceRow(): void {
    if (this.fedReferenceGridInstance) {
      this.fedReferenceGridInstance.addRow();
    }
  }

  onFedReferenceInitNewRow(e: any): void {
    e.data.key = this.generateLoanNumberKey();
  }

  onFedReferenceGridRowCommitted(): void {
    if (!this.taskToEdit || !(this.taskToEdit as any).parsedTaskData) return;

    const rows = [...this.fedReferenceGridRows];
    (this.taskToEdit as any).parsedTaskData.fedReferenceNumbers = rows;
    this.taskToEdit.taskData = JSON.stringify((this.taskToEdit as any).parsedTaskData);

    this.buttonTextSubject$.next('Save Changes');
    this.setIsDirty(true);
    this.buttonEditorOptions = { disabled: false };
  }

   hasFieldBeenEdited(fieldKey: string): boolean {
     // Check if the current value differs from the original value OR if it exists in historical edits
     if (!this.taskToEdit || !(this.taskToEdit as any).parsedTaskData) return false;

     // Check if field exists in the editedFields history (from previous saves)
     const editedFields = (this.taskToEdit as any).parsedTaskData.editedFields;
     const hasHistoricalEdit = editedFields && Array.isArray(editedFields) &&
                               editedFields.some((edit: any) => edit.name === fieldKey);

     // If we don't have an original value tracked, only check historical edits
     if (!this.originalFieldValues.hasOwnProperty(fieldKey)) {
       return hasHistoricalEdit;
     }

     // Compare current value with original value for real-time changes
     const currentValue = (this.taskToEdit as any).parsedTaskData[fieldKey];
     const originalValue = this.originalFieldValues[fieldKey];
     const hasCurrentEdit = currentValue !== originalValue;

     // Return true if field has been edited in current session OR has historical edits
     return hasCurrentEdit || hasHistoricalEdit;
   }

   captureOriginalFieldValues(): void {
     // Clear previous original values and pending changes
     this.originalFieldValues = {};
     this.pendingFieldChanges = [];
     this.temporaryFieldChanges = {};

     if (!this.taskToEdit?.taskId || !(this.taskToEdit as any).parsedTaskData) return;

     // Extract the prefix from taskId
     const taskPrefix = this.taskToEdit.taskId.substring(0, 3).toUpperCase();

     const editableFields = this.getEditableFieldsForPrefix(taskPrefix);

     if (editableFields.length === 0) return;

     // Store original values for all editable fields
     editableFields.forEach((field: any) => {
       const fieldName = typeof field === 'string' ? field : field.name;
       const currentValue = (this.taskToEdit as any).parsedTaskData[fieldName];
       this.originalFieldValues[fieldName] = currentValue;
     });
   }

   async appendEditedFieldsToTaskData(): Promise<void> {
     if (this.pendingFieldChanges.length === 0) return;

     if (!this.taskToEdit || !(this.taskToEdit as any).parsedTaskData) return;

     // Get current editedFields array or create new one
     let editedFields = (this.taskToEdit as any).parsedTaskData.editedFields || [];

     // Get current date/time in UTC with locale offset
     const now = new Date();
     const offsetMinutes = now.getTimezoneOffset();
     const offsetHours = Math.abs(offsetMinutes / 60);
     const offsetSign = offsetMinutes <= 0 ? '+' : '-';
     const formattedOffset = `${offsetSign}${String(Math.floor(offsetHours)).padStart(2, '0')}:${String(Math.abs(offsetMinutes % 60)).padStart(2, '0')}`;
     const timestamp = `${now.toISOString().slice(0, -1)}${formattedOffset}`;

     // Get user information from localStorage
     const loggedInUser = localStorage.getItem('loggedInUser') || 'Unknown User';
     const loggedInUserId = localStorage.getItem('loggedInUserId');

     // Add each pending change to editedFields and post comment to API
     for (const change of this.pendingFieldChanges) {
       editedFields.push({
         name: change.name,
         date: timestamp,
         oldValue: change.oldValue,
         newValue: change.newValue
       });

       // Post comment to API if comment exists
       if (change.comment) {
         try {
           // Format the field name for display
           const formattedFieldName = this.formatAndCapitalizePipe.transform(change.name);

           // Format the values for display
           const formattedOldValue = this.formatFieldValueForDisplay(change.name, change.oldValue);
           const formattedNewValue = this.formatFieldValueForDisplay(change.name, change.newValue);

           // Create the comment text in the specified format
           const commentText = `Field: ${formattedFieldName}, Old Value: ${formattedOldValue}, New Value: ${formattedNewValue}, Changed on: ${timestamp}, Changed by: ${loggedInUser}`;

           // Create the task comment object
           const taskComment: ITaskCommentPost = {
             taskId: this.selectedTask.id,
             headline: `Field Change: ${formattedFieldName}`,
             comment: commentText + '\n\n' + change.comment,
             commenterId: loggedInUserId,
             actionDate: now,
             logEntryTypeId: '00000000-0000-0000-0000-000000000000',
             mentions: []
           };

           // Post the comment via API
           await lastValueFrom(this.taskDataService.postComment(taskComment));
         } catch (err: any) {
           this.loggingService.logError(`Failed to post field change comment for field: ${change.name}`, SeverityLevel.Error);
           this.loggingService.logError(err, SeverityLevel.Error);
           // Continue with other changes even if one fails
         }
       }
     }

     // Update parsedTaskData with the new editedFields array (remove changeComments)
     (this.taskToEdit as any).parsedTaskData.editedFields = editedFields;

     // Update the JSON string
     this.taskToEdit.taskData = JSON.stringify((this.taskToEdit as any).parsedTaskData);

     // Clear pending changes since they're now saved
     this.pendingFieldChanges = [];
   }

   getTaskById : () =>  Promise<void> = async () =>
   {
     try{

      this.setIsDirty(false);
      if(!this.isTaskDetailLoaded)
        {   const taskData = await lastValueFrom(this.taskDataService.getTaskById(this.selectedTask.id));
            console.log(taskData);
            this.taskToEditSubject$.next(taskData[1]);
        }
        else{
          this.taskToEditSubject$.next(this.selectedTask);
        }
      await this.getUserData();

      // Initialize selectedUser based on assignedUserId or assignedUserName after user data is loaded
      console.log('Initializing assigned user. assignedUserId:', this.taskToEdit?.assignedUserId, 'assignedUserName:', this.taskToEdit?.assignedUserName);
      console.log('Available users count:', this.allUsers?.length);

      if (this.taskToEdit && this.allUsers && this.allUsers.length > 0) {
        const emptyGuid = '00000000-0000-0000-0000-000000000000';

        // Check if assignedUserId is set and not empty
        if (this.taskToEdit.assignedUserId && this.taskToEdit.assignedUserId !== emptyGuid) {
          console.log('Searching for user by ID:', this.taskToEdit.assignedUserId);

          // Find user by ID
          this.selectedUser = this.allUsers.find(user => user.id === this.taskToEdit.assignedUserId);

          if (this.selectedUser) {
            // Ensure the dropdown binding is set correctly
            this.taskToEdit['assignedUserId'] = this.selectedUser.id;
            console.log('✅ Assigned user pre-selected by ID:', this.selectedUser.name || (this.selectedUser as any).fullName, '(ID:', this.selectedUser.id, ')');
          } else {
            console.warn('❌ Assigned user ID not found in user list:', this.taskToEdit.assignedUserId);
            console.warn('This user may not be in the team. Consider loading from all users or adding them to the list.');

            // Fallback: Keep the assignedUserId in the taskToEdit so it can still be saved even if not in dropdown
            // But the dropdown won't show a selected value
          }
        }
        // Fallback: Try to find by name if ID is not available or empty
        else if (this.taskToEdit.assignedUserName) {
          console.log('Searching for user by name:', this.taskToEdit.assignedUserName);

          this.selectedUser = this.allUsers.find(user =>
            (user.name && user.name === this.taskToEdit.assignedUserName) ||
            ((user as any).fullName && (user as any).fullName === this.taskToEdit.assignedUserName)
          );

          if (this.selectedUser) {
            // Set the ID for the dropdown binding
            this.taskToEdit['assignedUserId'] = this.selectedUser.id;
            console.log('✅ Assigned user pre-selected by name:', this.selectedUser.name || (this.selectedUser as any).fullName, '(ID:', this.selectedUser.id, ')');
          } else {
            console.warn('❌ Assigned user name not found in user list:', this.taskToEdit.assignedUserName);
          }
        } else {
          // No assigned user
          console.log('No assigned user for this task');
          this.selectedUser = null;
          this.taskToEdit['assignedUserId'] = null;
        }

        // Trigger change detection to ensure the select box updates
        setTimeout(() => {
          this.ref.detectChanges();
        }, 0);
      } else {
        console.warn('Cannot initialize assigned user - taskToEdit or allUsers not available');
      }

      this.formatTaskData();

      if(this.chatInstance != null && this.chatInstance != undefined && this.chatInstance.isIntialized){
        this.chatInstance.setTaskIdAndGetPreviousMessages();
      }

      this.selectedTaskChanged = true;

     }
       catch(err: any)
       {
         this.loggingService.logError(err, SeverityLevel.Error);
         notify(err.message, 'error', this.utilService.getNotificationTimeout() );
         this.selectedTaskChanged = false;
       }

   }

  onSelectValueChanged(e: any) {
    // console.log("in onSelectValueChanged");
    if ( e.value !== e.previousValue) { //e.previousValue !== null &&
      this.setIsDirty(true);
      this.buttonEditorOptions = {
        disabled: false
      };
    }
    if (e.element?.classList.contains('w-100')) {
      // Get the complete selected item, not just the value
      const selectedItem = e.component.option('selectedItem');
      this.selectedUser = selectedItem;

      // Also update the taskToEdit for binding
      this.taskToEdit['assignedUserId'] = e.value;
    }
  }

   onFileUpload(file: File)
   {
    if(file != null && file != undefined)
    {
      this.files.push(file);
      this.setIsDirty(true);
    }

   }
  onFileRemove(file: File)
   {
    if(file != null && file != undefined)
    {
      this.files = this.files.filter(f => f !== file);
    }
   }

   setIsDirty(isDirty: boolean)
   {
    this.isDirtySubject$.next(isDirty);
    this.buttonEditorOptions ={  text: this.buttonText, useSubmitBehavior: true, disabled: !this.isDirty};
   }






   checkAttachments(){
    if(this.selectedTask != null && this.selectedTask != undefined)
    {
      if(!this.selectedTask.parentId){
        return this.selectedTask.urls && this.selectedTask.urls.length > 0;
      }else{
        return this.selectedTask.parentUrls && this.selectedTask.parentUrls.length > 0;
      }
    }
    return false;
   }


  ngOnChanges(changes: SimpleChanges)
  {

      if(changes['selectedTask'])
      {
        if(this.selectedTask != null)
          {
            this.hasAttchments = this.checkAttachments();
            this.objectKeys = ["taskType","name","taskId","referenceName"];
            this.getTaskById();
            this.contentTitle = this.selectedTask.name;
            this.ref.detectChanges();
          }
      }
  }

  onSectionClick1(e: any) {
    const clickedItem = e.itemData;
    const index = this.selectedItems.indexOf(clickedItem);
    // If the clicked item is currently selected (open)
    if (index > -1) {
      // If it's the only one open, prevent collapse
      if (this.selectedItems.length === 1) {
        e.event.preventDefault();
        return;
      } else {
        // Allow collapse
        this.selectedItems.splice(index, 1);
      }
    } else {
      // Add the newly opened item
      this.selectedItems.push(clickedItem);
    }
  }

  async onSectionClick(e){
    // Remove chat loading from here since onAccordionSelectionChanged handles it
    // This can be used for other section-specific logic if needed
  }

  async onAccordionSelectionChanged(e){
    // Handle accordion selection change - this fires after the accordion expands
    if (e.addedItems && e.addedItems.length > 0) {
      const selectedSection = e.addedItems[0];
      if (selectedSection == 'Chat') {
        // Add a small delay to ensure the chat component is rendered
        setTimeout(() => {
          this.loadChat();
        }, 100);
      }
    }
  }

  async loadChat(){
    // Check if chat instance is available before calling the method
    if (this.chatInstance && this.chatInstance.setTaskIdAndGetPreviousMessages) {
      this.chatInstance.setTaskIdAndGetPreviousMessages();
    } else {
      // If chat instance is not ready, try again after a short delay
      setTimeout(() => {
        if (this.chatInstance && this.chatInstance.setTaskIdAndGetPreviousMessages) {
          this.chatInstance.setTaskIdAndGetPreviousMessages();
        }
      }, 200);
    }
  }

  ngOnInit() {
    this.markAsComplete = this.selectedTask.status == 'Closed';
    this.notApplicable = this.selectedTask.status == 'Not Applicable';
    this.selectedItems = [this.sections[this.selectedSectionIndex]];
  }

  ngAfterViewInit() {
    // Enable mouse wheel scrolling on the accordion
    if (this.accordionElement && this.accordionElement.nativeElement) {
      const accordionContainer = this.accordionElement.nativeElement;

      // Add wheel event listener to ensure scrolling works
      this.renderer.listen(accordionContainer, 'wheel', (event: WheelEvent) => {
        // Check if the accordion itself is scrollable
        const hasVerticalScrollbar = accordionContainer.scrollHeight > accordionContainer.clientHeight;

        if (hasVerticalScrollbar) {
          // Allow the event to propagate naturally for accordion scrolling
          // but prevent it from bubbling to parent if we're at scroll boundaries
          const isScrollingDown = event.deltaY > 0;
          const isScrollingUp = event.deltaY < 0;
          const isAtTop = accordionContainer.scrollTop === 0;
          const isAtBottom = accordionContainer.scrollTop + accordionContainer.clientHeight >= accordionContainer.scrollHeight - 1;

          // Prevent parent scroll when not at boundaries
          if ((isScrollingDown && !isAtBottom) || (isScrollingUp && !isAtTop)) {
            event.stopPropagation();
          }
        }
      });
    }
  }


}
@NgModule({
  imports: [  CommonModule ],

})
export class TaskDetailModule { }
